import type { MessageKey } from "./ru"

export const kkMessages = {
  "common.loading": "Жүктелуде...",
  "common.error": "Қате",
  "common.back": "Артқа",
  "common.next": "Келесі",
  "common.search": "Іздеу",
  "auth.loginErrorTitle": "Кіру қатесі",
  "auth.openViaTelegram": "Қолданбаны Telegram арқылы ашыңыз",
  "auth.telegramRequired": "Қолданба Telegram арқылы ашылуы керек",
  "auth.authorizationError": "Авторизация қатесі",
  "device.rotatePortrait": "Құрылғыны тік күйге бұрыңыз",
  "country.brazil": "Бразилия",
  "country.vietnam": "Вьетнам",
  "country.egypt": "Мысыр",
  "country.india": "Үндістан",
  "country.indonesia": "Индонезия",
  "country.iran": "Иран",
  "country.spain": "Испания",
  "country.italy": "Италия",
  "country.kazakhstan": "Қазақстан",
  "country.colombia": "Колумбия",
  "country.malaysia": "Малайзия",
  "country.mexico": "Мексика",
  "country.nigeria": "Нигерия",
  "country.pakistan": "Пәкістан",
  "country.russia": "Ресей",
  "country.usa": "АҚШ",
  "country.turkey": "Түркия",
  "country.uzbekistan": "Өзбекстан",
  "country.ukraine": "Украина",
  "country.philippines": "Филиппин",
  "countrySelection.chooseCountry": "Елді таңдаңыз",
  "countrySelection.openAria": "Елді таңдау",
  "languageSelection.chooseLanguage": "Тілді таңдаңыз",
  "commercial.direction.autotrade": "Автонарық",
  "commercial.direction.insurance": "Сақтандыру",
  "commercial.direction.pitstop": "Пит-стоп",
  "commercial.direction.techhelp": "Жол көмегі",
  "commercial.searchLabel": "BeepApp іздеуі",
  "commercial.cityPlaceholder": "Қаланы енгізіңіз",
  "commercial.emptyTitle": "Бүгін ұсыныс жоқ",
  "commercial.emptyLine1": "Сіздің қалаңызда әзірге белсенді BeepApp серіктестері жоқ",
  "commercial.emptyLine2": "Біз оларды іздеп, қосуды бастап кеттік",
  "commercial.emptyLine3": "Жаңа ұсыныстар мұнда автоматты түрде пайда болады",
  "commercial.helperLine1": "Қолжетімді ұсыныстарды көру үшін",
  "commercial.helperLine2": "қалаңызды көрсетіңіз",
  "commercial.partnerPrompt": "BeepApp серіктесі болғыңыз келе ме?",
  "commercial.apply": "Өтінім беру",
  "main.admin": "Әкімші",
  "main.garage": "Гараж",
  "main.signalSent": "Сигнал жіберілді",
  "main.partnerInviteUnavailable": "Серіктестік шақыру қолжетімсіз",
  "main.enterPlate": "Мемлекеттік нөмірді енгізіңіз",
  "main.searchError": "Іздеу қатесі",
  "main.signalSendError": "Сигнал жіберілмеді",
  "main.shareCardPrefix": "Нөмір картасы",
  "main.shareLinkError": "Сілтеме дайындалмады",
  "main.searchByPlateAria": "Мемлекеттік нөмір бойынша іздеу",
  "main.russianPlateAria": "Ресейлік мемлекеттік нөмір",
  "main.plateAria": "Мемлекеттік нөмір",
  "main.findPlateAria": "Нөмірді табу",
  "main.loadingVehicle": "Нөмір картасы жүктелуде…",
  "main.leaveSignal": "Сигнал қалдыру",
  "main.share": "Бөлісу",
  "signalSelection.chooseType": "Сигнал түрін таңдаңыз",
  "signalSelection.category.attention": "Жеке",
  "signalSelection.category.road": "Жол",
  "signalSelection.category.urgent": "Шұғыл",
  "signalSelection.chooseSignal": "Сигналды таңдаңыз",
  "signalSelection.suggestOwn": "Өз нұсқаңызды ұсыныңыз",
  "signalConfirmation.title": "Сигналды растау",
  "signalConfirmation.plateHeading": "Көлік нөмірін тексеріңіз",
  "signalConfirmation.signalHeading": "Таңдалған сигналды тексеріңіз",
  "signalConfirmation.replyTitle": "Telegram-да жауап беруге рұқсат ету",
  "signalConfirmation.replyBody": "Осыны қоссаңыз, нөмір иесі сізге\nTelegram арқылы жаза алады. Жауап тек сізде\n@username болса мүмкін. Жауап беру-бермеуді\nнөмір иесі өзі шешеді.",
  "signalConfirmation.consentText": "Сигнал нақты жағдайға сәйкес екенін\nжәне спам немесе жалған хабарлама\nемес екенін растаймын.",
  "signalConfirmation.warning": "Жібергеннен кейін сигналды\nөзгерту мүмкін болмайды",
  "signalConfirmation.sending": "Жіберілуде…",
  "signalConfirmation.send": "Жіберу",
  "partner.loadingAria": "Жүктелуде",
  "partner.title": "Серіктестік бағдарлама",
  "partner.offerLine1": "Барлық төлемнен мерзімсіз 30% алыңыз",
  "partner.offerLine2": "BeepApp-қа сіз шақырған пайдаланушылардан",
  "partner.offerLine3": "Telegram affiliate бағдарламасы арқылы",
  "partner.connectUnavailable": "Telegram Affiliate бағдарламасы бапталғаннан кейін қосылу қолжетімді болады.",
  "partner.connectTelegram": "Telegram-да қосылу",
  "partner.qrAria": "Серіктестік сілтеменің QR-коды",
  "partner.download": "Жүктеп алу",
  "partner.promoHeading": "Жеке промокод жасаңыз",
  "partner.promoHelperLine1": "Промокод жазылымның қосымша бір жылын іске қосады",
  "partner.promoHelperLine2": "және пайдаланушыларды тартуға көмектеседі",
  "partner.promoAria": "Промокод",
  "partner.affiliateHeading": "Сіздің affiliate-сілтемеңіз",
  "partner.affiliateHelper": "Жеке QR-код жасау үшін сілтемені сақтаңыз",
  "partner.affiliateAria": "Affiliate-сілтеме",
  "partner.qrNoteLine1": "QR-кодты көлікке,",
  "partner.qrNoteLine2": "әлеуметтік желілерге және жарнама материалдарына орналастыруға болады",
  "partner.save": "Сақтау",
  "partner.reset": "Қалпына келтіру",
  "partner.resetConfirm": "Сақталған affiliate-сілтемені қалпына келтіру керек пе? Промокод сізде қалады.",
  "partner.promoFormatError": "Промокод 4-тен 15 таңбаға дейін болуы керек.",
  "partner.affiliateHostError": "Тек t.me немесе telegram.me сілтемелеріне рұқсат етіледі.",
  "partner.affiliatePathError": "Сілтемеде Telegram жолы жоқ.",
  "partner.affiliateFormatError": "Affiliate-сілтеме қате.",
  "partner.loadError": "Жүктеу қатесі",
  "partner.checkInputError": "Енгізілген деректерді тексеріңіз",
  "garageActivation.promoInvalid": "Промокод жарамсыз",
  "garageActivation.plateOccupied": "Бұл мемлекеттік нөмір әлдеқашан тіркелген",
  "garageActivation.activateError": "Гаражды іске қосу мүмкін болмады",
  "garageEntry.loadJournalError": "Журнал жүктелмеді",
  "garageEntry.loadStatusesError": "Статустар жүктелмеді",
  "garageEntry.activationSuccess": "Гараж сәтті іске қосылды",
  "garageEntry.plateAttached": "Нөмір тіркелді",
  "garageEntry.attachError": "Нөмірді тіркеу мүмкін болмады",
  "garageEntry.activationNote": "Гаражыңызды іске қосыңыз",
  "garageSheet.activationTitle": "Гаражды іске қосу",
  "garageSheet.plateHelper": "Көліктің мемлекеттік нөмірін енгізіңіз",
  "garageSheet.promoHelper": "Промокодыңыз бар ма?",
  "garageSheet.cleanBonusLine1": "Іске қосылғаннан кейін сізде 1 сағат болады",
  "garageSheet.cleanBonusLine2": "тегін «Таза бастау» үшін",
  "garageSheet.activationFor": "Іске қосу мерзімі",
  "garageSheet.cost": "Құны",
  "garageSheet.ownerConsentLine1": "Көрсетілген мемлекеттік нөмірі бар",
  "garageSheet.ownerConsentLine2": "көлік құралының иесі екенімді",
  "garageSheet.ownerConsentLine3": "растаймын.",
  "garageSheet.processing": "Орындалуда...",
  "garageSheet.attach": "Тіркеу",
  "garageSheet.pay": "Төлеу",
  "garageLifecycle.cleanTitle": "Таза бастау",
  "garageLifecycle.deactivateTitle": "Гаражды өшіру",
  "garageLifecycle.cleanWarningLine1": "Нөмір тарихы жойылады",
  "garageLifecycle.cleanWarningLine2": "және оны қалпына келтіру мүмкін болмайды!",
  "garageLifecycle.deactivateWarningLine1": "Өшіргеннен кейін белсенді Гараж",
  "garageLifecycle.deactivateWarningLine2": "функцияларына қолжетімділік тоқтайды",
  "garageLifecycle.willBeDeleted": "ЖОЙЫЛАДЫ",
  "garageLifecycle.cleanRemovedLine1": "• Борт журналындағы барлық жазба",
  "garageLifecycle.cleanRemovedLine2": "• Алынған сигналдар тарихы",
  "garageLifecycle.cleanRemovedLine3": "• Қоғамдық сигнал есептегіштері",
  "garageLifecycle.cleanRemovedLine4": "  нөмір картасында",
  "garageLifecycle.willRemain": "САҚТАЛАДЫ",
  "garageLifecycle.cleanPreservedLine1": "• Нөмірдің Гаражға байланысы",
  "garageLifecycle.cleanPreservedLine2": "• Қалған іске қосу мерзімі",
  "garageLifecycle.cleanPreservedLine3": "• Таңдалған нөмір статусы",
  "garageLifecycle.cleanPreservedLine4": "• Нөмір картасының жалпы қаралым саны",
  "garageLifecycle.freeFirstHour": "Алғашқы сағатта тегін",
  "garageLifecycle.willBecomeUnavailable": "ҚОЛЖЕТІМСІЗ БОЛАДЫ",
  "garageLifecycle.deactivateRemovedLine1": "• Борт журналы",
  "garageLifecycle.deactivateRemovedLine2": "• Нөмір статусын таңдау және пайдалану",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan-нан автоматты түрде шығасыз",
  "garageLifecycle.deactivateRemovedLine4": "• Автонарық",
  "garageLifecycle.deactivateRemovedLine5": "• Сақтандыру",
  "garageLifecycle.deactivateRemovedLine6": "• Пит-стоп",
  "garageLifecycle.deactivateRemovedLine7": "• Жол көмегі",
  "garageLifecycle.deactivateRemovedLine8": "• Мемлекеттік нөмір Гараждан ажыратылады",
  "garageLifecycle.willRemainAvailable": "ҚОЛЖЕТІМДІ БОЛЫП ҚАЛАДЫ",
  "garageLifecycle.deactivatePreservedLine1": "• Серік",
  "garageLifecycle.deactivatePreservedLine2": "• Диспетчер",
  "garageLifecycle.deactivatePreservedLine3": "• Мемлекеттік нөмір бойынша іздеу және",
  "garageLifecycle.deactivatePreservedLine4": "  көліктің қоғамдық картасын көру",
  "garageLifecycle.deactivatePreservedLine5": "• Кез келген уақытта Гаражды",
  "garageLifecycle.deactivatePreservedLine6": "  қайта іске қосу мүмкіндігі",
  "garageLifecycle.cleanConsentLine1": "Осы нөмірдің бүкіл тарихын",
  "garageLifecycle.cleanConsentLine2": "қалпына келтіру мүмкіндігінсіз жоюға",
  "garageLifecycle.cleanConsentLine3": "келісемін.",
  "garageLifecycle.deactivateConsentLine1": "Өшіруді және белсенді Гараждың",
  "garageLifecycle.deactivateConsentLine2": "барлық функциясына қолжетімділіктің",
  "garageLifecycle.deactivateConsentLine3": "тоқтауын растаймын.",
  "garageLifecycle.clean": "Тазалау",
  "garageLifecycle.deactivate": "Өшіру",
} satisfies Record<MessageKey, string>
